<script>
import {useProductStore} from "@js/store/ProductStore.js";
import CatalogProductItem from "@js/components/Sections/Catalog/ProductItem/CatalogProductItem.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";
import CatalogProductSkeleton from "@js/components/Sections/Catalog/ProductItem/CatalogProductSkeleton.vue";
import {Link} from "@inertiajs/vue3";

export default {
    name: "ProductCollectionProductSlider",
    components: {
        Link,
        CatalogProductSkeleton,
        IconAngleLeft,
        CatalogProductItem,
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            swiper: null,
            breakpoints: {
                320: {slidesPerView: 1.2, spaceBetween: 10},
                1024: {slidesPerView: 2, spaceBetween: 20},
                1400: {slidesPerView: 4, spaceBetween: 20},
            }
        }
    },
    methods: {
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance;
        },
        slideNext() {
            if (this.swiper) this.swiper.slideNext();
        },
        slidePrev() {
            if (this.swiper) this.swiper.slidePrev();
        },
    },
    mounted() {
        this.productStore.getCollectionProducts()
    },
    computed: {
        maxSlidesPerView() {
            return Math.max(
                ...Object.values(this.breakpoints).map(bp => bp.slidesPerView)
            )
        },
    },
    setup() {
        const productStore = useProductStore()

        return {
            productStore,
        }
    }
}
</script>

<template>
    <div>
        <div v-if="!productStore.loadings.collectionProductLoading">
            <h2 class="mb-5 text-2xl font-medium">
                Товары коллекции «{{ productStore.product.collections[0].title }}»
            </h2>
            <div>
                <Swiper :slides-per-view="4"
                        :space-between="20"
                        @swiper="setSwiper"
                        :loop="productStore.collectionProduct.length > maxSlidesPerView"
                        :breakpoints="breakpoints"
                        :autoplay="{ delay: 5000, disableOnInteraction: true }"
                        class="pagination-base long_bullet bg-transparent h-[525px]">
                    <SwiperSlide v-for="(product, key) in productStore.collectionProduct">
                        <CatalogProductItem :data="product" :key="key"
                                            :animation_on="false"
                                            class="h-full"/>
                    </SwiperSlide>
                </Swiper>
            </div>
            <div class="flex items-end justify-between mt-5 max-md:me-5">
                <div class="flex gap-3 max-md:hidden"
                     v-if="productStore.collectionProduct.length > maxSlidesPerView">
                    <button v-if="swiper" @click.prevent="slidePrev" aria-label="Назад"
                            class="bg-baseColor md:hover:bg-baseColor/70 rounded-full w-[44px] h-[44px] flex items-center justify-center transition">
                        <IconAngleLeft class="w-5 h-5 stroke-black"/>
                    </button>
                    <button v-if="swiper" @click.prevent="slideNext" aria-label="Вперед"
                            class="bg-baseColor md:hover:bg-baseColor/70 rounded-full w-[44px] h-[44px] flex items-center justify-center transition">
                        <IconAngleLeft class="w-5 h-5 stroke-black rotate-180"/>
                    </button>
                </div>
                <Link :v-if="productStore.product.collections[0].slug"
                      :href="route('showCollection', {slug: productStore.product.collections[0].slug})"
                      class="w-full md:w-auto text-center text-black border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg md:text-sm px-10 py-2.5 focus:outline-none transition">
                    Просмотр коллекции
                </Link>
            </div>
        </div>
        <div v-else>
            <div class="h-8 bg-gray-200 animate-pulse rounded w-1/4 mb-4"></div>
            <Swiper :slides-per-view="4"
                    :space-between="30"
                    @swiper="setSwiper"
                    :breakpoints="breakpoints"
                    :autoplay="{ delay: 5000, disableOnInteraction: true }"
                    class="pagination-base long_bullet bg-transparent">
                <SwiperSlide v-for="i in 4">
                    <CatalogProductSkeleton/>
                </SwiperSlide>
            </Swiper>
            <div class="flex gap-3 mt-5">
                <div class="rounded-full animate-pulse h-10 w-10 bg-gray-200"></div>
                <div class="rounded-full animate-pulse h-10 w-10 bg-gray-200"></div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
